import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('contact.hero.title')}</h1>
          <p className="text-xl max-w-3xl">
            {t('contact.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Contact Information */}
            <div className="lg:w-1/3">
              <h2 className="text-3xl font-bold mb-8">{t('contact.info.title')}</h2>
              
              <div className="space-y-6">
                {/* Address */}
                <div className="flex">
                  <div className="bg-primary/10 p-3 rounded-full mr-4 h-min">
                    <FaMapMarkerAlt className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{t('contact.info.location.title')}</h3>
                    <p className="text-gray-300">
                      {t('contact.info.location.address1')}<br />
                      {t('contact.info.location.address2')}<br />
                      {t('contact.info.location.country')}
                    </p>
                  </div>
                </div>
                
                {/* Phone */}
                <div className="flex">
                  <div className="bg-primary/10 p-3 rounded-full mr-4 h-min">
                    <FaPhone className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{t('contact.info.phone.title')}</h3>
                    <p className="text-gray-300">
                      <a href="tel:+903322390409" className="hover:text-primary">+90 332 239 04 09</a><br />
                      <a href="tel:+905544946406" className="hover:text-primary">+90 554 494 64 06</a>
                    </p>
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex">
                  <div className="bg-primary/10 p-3 rounded-full mr-4 h-min">
                    <FaEnvelope className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{t('contact.info.email.title')}</h3>
                    <p className="text-gray-300">
                      <a href="mailto:info@celiksacglobal.com" className="hover:text-primary">info@celiksacglobal.com</a>
                    </p>
                  </div>
                </div>
                
                {/* Business Hours */}
                <div className="flex">
                  <div className="bg-primary/10 p-3 rounded-full mr-4 h-min">
                    <FaClock className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{t('contact.info.hours.title')}</h3>
                    <p className="text-gray-300">
                      {t('contact.info.hours.weekdays')}<br />
                      {t('contact.info.hours.saturday')}<br />
                      {t('contact.info.hours.sunday')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Contact Form */}
            <div className="lg:w-2/3 bg-dark-light rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-6 text-white">{t('contact.form.title')}</h2>
              <form onSubmit={(e) => e.preventDefault()}>
                {/* WhatsApp yönlendirme fonksiyonu */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="fullName" className="block text-sm font-medium text-gray-300 mb-1">
                      {t('contact.form.fullName')} *
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      className="w-full px-4 py-2 border border-gray-600 bg-dark-medium text-white rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1">
                      {t('contact.form.email')} *
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-2 border border-gray-600 bg-dark-medium text-white rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-1">
                      {t('contact.form.phone')}
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      className="w-full px-4 py-2 border border-gray-600 bg-dark-medium text-white rounded-md focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-300 mb-1">
                      {t('contact.form.subject')} *
                    </label>
                    <input
                      type="text"
                      id="subject"
                      className="w-full px-4 py-2 border border-gray-600 bg-dark-medium text-white rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                </div>
                
                <div className="mb-6">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-1">
                    {t('contact.form.message')} *
                  </label>
                  <textarea
                    id="message"
                    rows="6"
                    className="w-full px-4 py-2 border border-gray-600 bg-dark-medium text-white rounded-md focus:ring-primary focus:border-primary"
                    required
                  ></textarea>
                </div>
                
                <div className="flex items-center mb-6">
                  <input
                    type="checkbox"
                    id="consent"
                    className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                    required
                  />
                  <label htmlFor="consent" className="ml-2 block text-sm text-gray-300">
                    {t('contact.form.consent')}
                  </label>
                </div>
                
                <button
                  type="submit"
                  className="bg-primary hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md transition-colors duration-300"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://wa.me/905544946406', '_blank');
                  }}
                >
                  {t('contact.form.submit')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-dark-medium">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">{t('contact.map.title')}</h2>
            <div className="bg-dark-light p-4 rounded-lg shadow-md overflow-hidden">
              <div className="h-96 w-full">
                {/* Replace with actual Google Maps embed */}
                <iframe
                  title={t('contact.map.mapTitle')}
                  className="w-full h-full border-0"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3139.610944931008!2d32.60605222356238!3d37.97729036524558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDU4JzM4LjIiTiAzMsKwMzYnMzEuMSJF!5e0!3m2!1str!2str!4v1687510099003!5m2!1str!2str"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
